module.exports = __webpack_public_path__ + "img/coverage.ad3cd4c.png";